<div [class.dark-theme]="true" class="fix-action-dialog">
	<ng-container *ngIf="lang === 'ja'">
		<mat-dialog-content data-idtest="policy-dialog-s-3Rx" (scroll)="onScroll($event)" fxLayout="column">
			<ng-container>
				<div style="background: linear-gradient(#242424,#141414);">
					<div style="padding:16px; color: #ffffff;">
						<div style="font-weight: 600;font-size:32px;">
							<div class="card-title">利用規約</div>
						</div>
					</div>
					<mat-card style="margin:16px;">
						<mat-card-content>

							<div #agreement fxLayout="column" fxLayoutAlign="space-between" style="font-size:16px;line-height:1.5">
								<div style="font-size:18px;margin:8px;font-weight:900">利用規約</div>

								<div style="font-size:14px;margin:8px;">本利用規約（以下「本規約」といいます。）には、本サービスの提供条件及び当社と登録ユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいた上で、本規約に同意いただく必要があります。</div>

								<div class="article-1">
									<div class="title-1">（適用）</div>
									<div class="title-2">第１条</div>
									<div class="text-1">
										本規約は、本サービスの提供条件及び本サービスの利用に関する当社と登録ユーザーとの間の権利義務関係を定めることを目的とし、登録ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（定義）</div>
									<div class="title-2">第２条</div>
									<div class="text-1">
										　本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。<br/>
										⑴　「サービス利用契約」とは、本規約の契約条件として当社と登録ユーザーの間で締結される、本サービスの利用契約を意味します。<br/>
										⑵　「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。<br/>
										⑶　「投稿データ」とは、登録ユーザーが本サービスを利用して投稿その他送信するコンテンツ（文書、画像、動画その他のデータを含みますが、これらに限りません。）を意味します。<br/>
										⑷　当社とは、株式会社ＡＩＧＩＡを意味します。<br/>
										⑸　「当社ウェブサイト」とは、そのドメインが「aigia.jp」である、当社が運営するウェブサイト（理由のいかんを問わず、当社のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。<br/>
										⑹　「登録ユーザー」とは、第３条（登録）に基づいて本サービスの利用者としての登録がなされた個人を意味します。<br/>
										⑺　「本サービス」とは、当社が提供するＡＩＧＩＡシステムという名称のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（登録）</div>
									<div class="title-2">第３条</div>
									<div class="text-1">
										　本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録事項」といいます。）を、当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。<br/>
										２　当社は、当社の基準に従って、第１項に基づいて登録申請を行った登録希望者（以下「登録申請者」といいます。）の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者の登録ユーザーとしての登録は、当社が本項の通知を行ったことをもって完了したものとします。<br/>
										３　前項に定める登録の完了時に、サービス利用契約が登録ユーザーと当社の間に成立し、登録ユーザーは本サービスを本契約に従い利用することができるようになります。<br/>
										４　当社は、登録申請者が、次の各号のいずれかの事由に該当する場合、登録および再登録を拒否することがあり、また、その理由について一切開示義務を負いません。<br/>
										⑴　当社に提供した登録事項の全部または一部につき虚偽、誤記または記載漏れがあった場合<br/>
										⑵　未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、法定代理人、後見人、保佐人または補助人の同意等を得ていなかった場合<br/>
										⑶　反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合<br/>
										⑷　過去当社との契約に違反した者またはその関係者であると当社が判断した場合<br/>
										⑸　第１０条に定める措置を受けたことがある場合<br/>
										⑹　その他、登録を相当でないと当社が判断した場合<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（登録事項の変更）</div>
									<div class="title-2">第４条</div>
									<div class="text-1">
										　登録ユーザーは、登録事項に変更があった場合、当社の定める方法により当該変更事項を遅滞なく当社に通知するものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（パスワードおよびユーザーＩＤの管理）</div>
									<div class="title-2">第５条</div>
									<div class="text-1">
										登録ユーザーは、自己の責任において、本サービスに関するパスワードおよびユーザーＩＤを適切に管理及び保管するものとし、これを第三者に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。<br/>
										２　パスワードまたはユーザーＩＤの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任は登録ユーザーが負うものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（料金及び支払方法）</div>
									<div class="title-2">第６条</div>
									<div class="text-1">
										　登録ユーザーは、本サービス利用の対価として、別途当社が定め、当社ウェブサイトに表示する利用料金を、当社が指定する支払方法により当社に支払うものとします。<br/>
										２　登録ユーザーが利用料金の支払を遅滞した場合、登録ユーザーは年１４．６％の割合による遅延損害金を支払います。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（禁止事項）</div>
									<div class="title-2">第７条</div>
									<div class="text-1">
										　登録ユーザーは、本サービスの利用にあたり、次の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。<br/>
										⑴　法令に違反する行為または犯罪行為に関連する行為<br/>
										⑵　当社、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為<br/>
										⑶　公序良俗に反する行為<br/>
										⑷　当社、本サービスの利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉その他の権利または利益を侵害する行為<br/>
										⑸　本サービスを通じ、以下に該当し、または該当すると当社が判断する情報を当社または本サービスの他の利用者に送信すること<br/>
										・過度に暴力的または残虐な表現を含む情報<br/>
										・コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報<br/>
										・当社、本サービスの他の利用者またはその他の第三者の名誉または信用を棄損する表現を含む情報<br/>
										・過度にわいせつな表現を含む情報<br/>
										・差別を助長する表現を含む情報<br/>
										・自殺、自傷行為を助長する表現を含む情報<br/>
										・薬物の不適切な利用を助長する表現を含む情報<br/>
										・反社会的な表現を含む情報<br/>
										・チェーンメール等の第三者への情報の拡散を求める情報<br/>
										・他人に不快感を与える表現を含む情報<br/>
										⑹　本サービスのネットワークまたはシステム等に過度な負荷をかける行為<br/>
										⑺　当社が提供するソフトウェアその他のシステムに対するリバースエンジニアリングその他の解析行為<br/>
										⑻　本サービスの運営を妨害するおそれのある行為<br/>
										⑼　当社のネットワークまたはシステム等への不正アクセス<br/>
										⑽　第三者に成りすます行為<br/>
										⑾　本サービスの他の利用者のＩＤまたはパスワードを利用する行為<br/>
										⑿　当社が事前に許諾しない本サービス上での宣伝、広告、勧誘、または営業行為<br/>
										⒀　本サービスの他の利用者の情報の収集<br/>
										⒁　当社、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為<br/>
										⒂　当社ウェブサイト上で掲載する本サービス利用に関するルールに抵触する行為<br/>
										⒃　反社会的勢力等への利益供与<br/>
										⒄　面識のない異性との出会いを目的とした行為<br/>
										⒅　前各号の行為を直接または間接に惹起し、または容易にする行為<br/>
										⒆　前各号の行為を試みること<br/>
										⒇　その他、当社が不適切と判断する行為<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（本サービスの提供の停止等）</div>
									<div class="title-2">第８条</div>
									<div class="text-1">
										　当社は、以下のいずれかに該当する場合には、登録ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。<br/>
										⑴　本サービスにかかるコンピューター・システムの点検、保守または更新作業を行う場合<br/>
										⑵　コンピュータ、通信回線等の障害、誤操作、過度なアクセスの集中、不正サクセス、ハッキング等により本サービスの運営ができなくなった場合<br/>
										⑶　地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営が困難となった場合<br/>
										⑷　その他、当社が停止または中断を必要と判断した場合<br/>
										２　当社は、本サービスの提供の停止または中断により、登録ユーザーまたは第三者が被ったいかなる不利益または損害について一切の責任を負わないものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（権利帰属）</div>
									<div class="title-2">第９条</div>
									<div class="text-1">
										　当社ウェブサイトおよび本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイトまたは本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（登録抹消等）</div>
									<div class="title-2">第１０条</div>
									<div class="text-1">
										　当社は、登録ユーザーが、以下の各号のいずれかの事由に該当をする場合には、事前の通知または催告することなく、登録ユーザーについて本サービスの利用を一時的に停止し、または登録ユーザーとしての登録を抹消することができます。<br/>
										⑴　本規約のいずれかの条項に違反した場合<br/>
										⑵　登録事項に虚偽の事実があることが判明した場合<br/>
										⑶　料金等の支払についての不履行があった場合<br/>
										⑷　支払い停止もしくは支払い不能となり、または破産手続き開始、民事再生手続き開始、会社更生手続開始、特別清算手続開始もしくはこれらに類する手続の開始の申立てがあった場合<br/>
										⑸　当社からの問合せその他の回答を求める連絡に対して、３０日間以上応答がない場合<br/>
										⑹　第３条第４項各号に該当する場合<br/>
										⑺　その他、当社が本サービスの利用または登録ユーザーとしての登録の継続を適当でないと判断した場合<br/>
										２　前項各号のいずれかの事由に該当した場合、登録ユーザーは、当社または売主に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社または売主に対して全ての債務の支払を行わなければなりません。<br/>
										３　前項各号のいずれかの事由に該当した場合、当社は、登録ユーザーに係る本サービスの全て又は一部のデータを抹消することができます。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（退会）</div>
									<div class="title-2">第１１条</div>
									<div class="text-1">
										　登録ユーザーは、当社所定の手続の完了により、本サービスから退会し、自己の登録ユーザーとしての登録を抹消することができます。<br/>
										２　退会にあたり、当社または売主に対して負っている債務がある場合は、登録ユーザーは、当社または売主に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社または売主に対して全ての債務の支払を行わなければなりません。<br/>
										３　退会後の利用者情報の取扱いについては、第１５条の規定に従うものとします。<br/>
										４　当社は、退会した登録ユーザーに係る本サービスの全て又は一部のデータを抹消することができます。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（本サービスの内容の変更、終了）</div>
									<div class="title-2">第１２条</div>
									<div class="text-1">
										　当社は、当社の都合により、登録ユーザーに通知することなく、本サービスの内容を変更し、または提供を中止し、終了することができます。<br/>
										２　当社は、前項の本サービス内容の変更等によって登録ユーザーに生じた損害について一切責任を負わないものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（保証の否認、免責事項等）</div>
									<div class="title-2">第１３条</div>
									<div class="text-1">当社は、本サービスが登録ユーザーの特定の目的に適合すること、期待する機能・商品価値・正確性・有用性を有すること、登録ユーザーによる本サービスの利用が登録ユーザーに適用のある法令または業界団体の内部規制等に適合すること、継続的に利用できること、および不具合が生じないことについて、明示又は黙示を問わず何ら保証するものではありません。<br/>
										２　当社は、本サービスに関して登録ユーザーが被った損害について一切の責任を負わないものとします。<br/>
										３　本サービスまたは当社ウェブサイトに関連して登録ユーザーと他の登録ユーザーまたは第三者との間において生じた取引、連絡、紛争等については、登録ユーザーが自己の責任によって解決するものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（秘密保持）</div>
									<div class="title-2">第１４条</div>
									<div class="text-1">
										　登録ユーザーは、本サービスに関連して当社が登録ユーザーに対して秘密に取り扱うことを求めて開示した非公知情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（利用者情報の取扱い）</div>
									<div class="title-2">第１５条</div>
									<div class="text-1">
										　当社による登録ユーザーの利用者情報の取扱いについては、別途当社プライバシーポリシーの定めによるものとし、登録ユーザーはこのプライバシーポリシーに従って当社が登録ユーザーの利用者情報を取り扱うことについて同意するものとします。<br/>
										２　当社は、登録ユーザーが当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用及び公開することができるものとし、登録ユーザーはこれに異議を唱えないものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（本規約等の変更）</div>
									<div class="title-2">第１６条</div>
									<div class="text-1">
										　当社は、当社が必要と認めた場合は、本規約を変更できるものとします。本規約を変更する場合、変更後の本規約の施行時期及び内容を当社ウェブサイト上での掲示その他の適切な方法により周知し、または登録ユーザーに通知します。ただし、法令上登録ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法で登録ユーザーの同意を得るものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（連絡・通知）</div>
									<div class="title-2">第１７条</div>
									<div class="text-1">
										本サービスに関する問合せその他登録ユーザーから当社に対する連絡または通知、および本規約の変更に関する通知その他当社から登録ユーザーに対する連絡または通知は、当社の定める方法で行うものとします。<br/>
										２　当社が登録事項に含まれるメールアドレスその他の連絡先に連絡または通知を行った場合、登録ユーザーは当該連絡または通知を受領したものとみなします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（サービス利用契約上の地位の譲渡等）</div>
									<div class="title-2">第１８条</div>
									<div class="text-1">
										登録ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務について、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。<br/>
										２　当社は、本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに登録ユーザーの登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、登録ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（反社会的勢力の排除）</div>
									<div class="title-2">第１９条</div>
									<div class="text-1">
										　登録ユーザーは、次の各号のいずれか一にも該当しないことを表明し、かつ将来にわたっても該当しないことを表明し、保証するものとします。<br/>
										⑴　自ら（法人その他の団体にあっては、自らの役員を含みます。）が、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロまたは特殊知能暴力集団等その他これらに準じる者（以下総称して「暴力団員等」といいます。）であること。<br/>
										⑵　登録ユーザーが法人その他の団体の場合にあっては、暴力団員等が経営を支配していると認められる関係を有すること。<br/>
										⑶　登録ユーザーが法人その他の団体の場合にあっては、暴力団員等が経営に実質的に関与していると認められる関係を有すること。<br/>
										⑷　自らもしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもって取引を行うなど、暴力団員等を利用していると認められる関係を有すること。<br/>
										⑸　暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること。<br/>
										⑹　登録ユーザーが法人その他の団体の場合にあっては、自らの役員または自らの経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること。<br/>
										２　登録ユーザーは、自らまたは第三者を利用して次の各号のいずれか一にでも該当する行為を行わないことを保証するものとします。<br/>
										⑴　暴力的な要求行為<br/>
										⑵　法的な責任を超えた不当な要求行為<br/>
										⑶　取引に関して、脅迫的な言動をし、または暴力を用いる行為<br/>
										⑷　風説を流布し、偽計を用い、または威力を用いて、当社の信用を毀損し、または当社の業務を妨害する行為<br/>
										⑸　その他前各号に準ずる行為<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（分離可能性）</div>
									<div class="title-2">第２０条</div>
									<div class="text-1">
										　本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">（準拠法及び管轄裁判所）</div>
									<div class="title-2">第２１条</div>
									<div class="text-1">
										　本規約およびサービス利用契約の準拠法は日本法とします。<br/>
										２　本規約またはサービス利用契約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。<br/>
									</div>
								</div>
								【令和３年９月１日制定】
							</div>

						</mat-card-content>
					</mat-card>
				</div>
			</ng-container>
		</mat-dialog-content>

		<div class="spacer"></div>

		<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around" style="margin:6px;">
			<button data-idtest="policy-dialog-b-8Lz" *ngIf="isEndScroll" color="primary" mat-dialog-close="" mat-raised-button>確認しました</button>
			<button *ngIf="!isEndScroll" [disabled]="!isEndScroll" color="primary" mat-raised-button>確認しました</button>
		</mat-dialog-actions>
	</ng-container>
	<ng-container *ngIf="lang === 'en'">
		<mat-dialog-content (scroll)="onScroll($event)" fxLayout="column">
			<ng-container>
				<div style="background: linear-gradient(#242424,#141414);">
					<div style="padding:16px; color: #ffffff;">
						<div style="font-weight: 600;font-size:32px;">
							<div class="card-title">Terms of Use</div>
						</div>
					</div>
					<mat-card style="margin:16px;">
						<mat-card-content>

							<div #agreement fxLayout="column" fxLayoutAlign="space-between" style="font-size:16px;line-height:1.5">
								<div style="font-size:18px;margin:8px;font-weight:900">Terms of Use</div>

								<div style="font-size:14px;margin:8px;">These Terms of Use (hereinafter referred to as the "Terms of Use") define the terms and conditions of the Service and the relationship of rights and obligations between the Company and all registered users. By using the Service, you agree to be bound by these Terms of Use after reading the entire text of the Terms of Use.</div>

								<div class="article-1">
									<div class="title-1">(Applicable)</div>
									<div class="title-2">Article 1.</div>
									<div class="text-1">
										The purpose of this Agreement is to set forth the terms and conditions of provision of the Service and the rights and obligations between the Company and the Registered Users with respect to the use of the Service, and shall apply to all relationships between the Registered Users and the Company with respect to the use of the Service.
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Definitions)</div>
									<div class="title-2">Article 2.</div>
									<div class="text-1">
										　The following terms used in this Agreement shall have the meanings set forth below.<br/>
										(1) "Service Agreement" means the agreement for use of the Service between the Company and a Registered User as the terms and conditions of this Agreement.<br/>
										(2) "Intellectual Property Rights" means copyrights, patents, utility model rights, design rights, trademarks, and other intellectual property rights (including the right to acquire such rights or to apply for registration of such rights). <br/>
										(3) "Posted data" means contents (including but not limited to documents, images, videos and other data) posted or transmitted by registered users using the Service. <br/>
										(4) "We" or "The company" mean AIGIA,Inc.<br/>
										(iv) "Our Website" means the website operated by us whose domain is "aigia.jp" (if the domain or content of our website is changed for any reason, including the website after such change). (iii) "Aigia.jp" shall mean "aigia.jp".<br/>
										⑹ "Registered User" means an individual who has been registered as a user of the Service in accordance with Article 3 (Registration).<br/>
										(iv) "Service" means the service named AIGIA System (if the name or content of the service is changed for any reason, including the service after such change) provided by AIGIA. means the service provided by AIGIA Systems, Inc.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Registration)</div>
									<div class="title-2">Article 3.</div>
									<div class="text-1">
										　A person who wishes to use the Service  (hereinafter referred to as "Applicant") agrees to abide by these Terms of Use and provides certain information as determined by the Company (hereinafter referred to as "Registration Matters").  The Company will register the applicant for use of the Service in accordance with the Company's standards.<br/>
										2. The Company shall determine whether or not to register the applicant who has applied for registration in accordance with the Company's standards in accordance with Article 1 (hereinafter referred to as the "Registration Applicant"). If the Company approves the registration, the Company will notify the Applicant of such approval or disapproval. The registration of the applicant as a registered user shall be deemed to have been completed when the Company has given the notice in this section.<br/>
										3 Upon completion of the registration as stipulated in the preceding paragraph, a service use agreement will be established between the registered user and the Company, and the registered user will be able to use the Service in accordance with this agreement.<br/>
										4 If any of the following reasons applies to an applicant for registration, the Company may refuse registration and re-registration, and shall not be obligated to disclose any reasons for such refusal.<br/>
										(1) In the event that all or part of the registration information provided to us is false, erroneous, or omitted.<br/>
										(2) If you are a minor, an adult ward, a person under curatorship or a person under assistance, and have not obtained the consent of your legal representative, guardian, curator or assistant.<br/>
										(3) If the company determines or you are a member of antisocial forces, etc. (meaning organized crime groups, members of organized crime groups, right-wing groups, antisocial forces, or other similar persons; the same shall apply hereinafter).  or is involved in any interaction or involvement with anti-social forces, etc. such as cooperation or involvement in the maintenance, operation or management of anti-social forces, etc. through financial provision.<br/>
										(4) If the Company determines that the person has violated a contract with the Company in the past or is related to such a person<br/>
										(5) If you have been subjected to any of the measures stipulated in Article 10.<br/>
										(6) In any other case in which the Company deems the registration is inappropriate.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Change of Registered Matters)</div>
									<div class="title-2">Article 4.</div>
									<div class="text-1">
										　The registered user shall notify the Company of any change in the registered information without delay in a manner determined by the Company.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Management of Password and User ID)</div>
									<div class="title-2">Article 5.</div>
									<div class="text-1">
										Registered Users shall, at their own responsibility, properly manage and store their passwords and user IDs for the Service, and shall not allow any third party to use them, or lend, transfer, change the name of, sell, or otherwise dispose of them.<br/>
										2 Registered Users shall be responsible for any damages caused by inadequate management of passwords or user IDs, errors in use, or use by third parties.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Fees and Payment Methods)</div>
									<div class="title-2">Article 6.</div>
									<div class="text-1">
										　Registered Users shall pay to the Company the usage fee separately determined by the Company and displayed on the Company's website as compensation for the use of the Service, by the payment method designated by the Company.<br/>
										2. If a Registered User delays payment of the Usage Fees, the Registered User shall pay a late fee at the rate of 14.6% per annum.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Prohibited Matters)</div>
									<div class="title-2">Article 7.</div>
									<div class="text-1">
										　In using the Service, Registered Users shall not engage in any of the following acts, or any act that the Company deems to fall under any of the following items<br/>
										(1) Actions that violate laws and regulations or are related to criminal acts.<br/>
										(2) Fraud or threat against the Company, other users of the Service or other third parties<br/>
										(3) Acts that are offensive to public order and morals<br/>
										(4) Infringement of intellectual property rights, portrait rights, privacy rights, honor, or other rights or interests of the Company, users of the Service, or other third parties<br/>
										(5) Transmitting information to the Company or other users of the Service through this Service that falls under or is deemed by the Company to fall under any of the following<br/>
										Information that contains excessively violent or cruel expressions<br/>
										Information that contains computer viruses or other harmful computer programs<br/>
										Information that contains expressions that defame or discredit the Company, other users of the Service, or other third parties<br/>
										Information that contains excessively obscene expressions<br/>
										Information that includes expressions that promote discrimination<br/>
										Information that encourages suicide or self-harm.<br/>
										Information that encourages the inappropriate use of drugs<br/>
										Information that contains antisocial expressions<br/>
										Information that requests the spread of information to a third party, such as chain mail<br/>
										Information that includes expressions that may cause discomfort to others<br/>
										(6) Actions that place an excessive load on the Service's network or system, etc.<br/>
										(7)Reverse engineering or other analysis of software or other systems provided by the Company<br/>
										(8) Acts that may interfere with the operation of this service<br/>
										(9) Unauthorized access to the Company's network or systems<br/>
										(10) Impersonation of a third party<br/>
										(11) Using IDs or passwords of other users of the Service<br/>
										(12) Advertising, publicity, solicitation, or sales activities on the Service that are not authorized in advance by the Company<br/>
										(13) Collection of information of other users of the Service<br/>
										(14)Acts that cause disadvantage, damage, or discomfort to the Company, other users of the Service, or other third parties<br/>
										(15) Violating the rules regarding the use of the Service posted on the Company's website<br/>
										(16) Provision of benefits to antisocial forces, etc.<br/>
										(17)Actions aimed at meeting people of the opposite sex whom you have never met<br/>
										(18)Actions that directly or indirectly cause or facilitate any of the aforementioned actions<br/>
										(19) Attempting to commit any of the acts listed in the preceding items<br/>
										(20)Other acts that the Company deems inappropriate.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Suspension of provision of the Service, etc.)</div>
									<div class="title-2">Article 8.</div>
									<div class="text-1">
										　In any of the following cases, the Company may suspend or discontinue all or part of the Service without prior notice to registered users.<br/>
										(1) When checking, maintaining, or updating computer systems related to the Service.<br/>
										(2) In the event of failure of computers, communication lines, etc., malfunction, mishandling, excessive concentration of access, unauthorized access, hacking, etc., which makes it impossible to operate this service.<br/>
										(3) In the event that the operation of the Service becomes difficult due to force majeure such as earthquake, lightning, fire, windstorm, flood, power outage, natural disaster, etc.<br/>
										(4) In any other cases where the Company deems it necessary to suspend or discontinue the Service.<br/>
										2. The Company shall not be liable for any disadvantage or damage incurred by a registered user or a third party due to the suspension or interruption of the Service.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Attribution of Rights)</div>
									<div class="title-2">Article 9.</div>
									<div class="text-1">
										　All intellectual property rights related to the Company's website and the Service belong to the Company or the party that has granted a license to the Company, and the permission to use the Service under this Agreement does not imply a license to use the intellectual property rights of the Company or the party that has granted a license to the Company regarding the Company's website or the Service. The license to use the Service under these Terms of Use shall not be construed as a license to use the intellectual property rights of the Company or any licensee of the Company's website or the Service.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Cancellation of Registration, etc.)</div>
									<div class="title-2">Article 10.</div>
									<div class="text-1">
										　In the event that a Registered User falls under any of the following items, the Company may, without prior notice or demand, temporarily suspend the Registered User's use of the Service or terminate the Registered User's registration.<br/>
										(1) If you violate any of the provisions of these Terms of Use.<br/>
										(2) If any false information is found in the registration information.<br/>
										(3) defaults in the payment of fees and other charges<br/>
										(4) If the Company is found to be in default in the payment of fees, etc. If the Company suspends or becomes insolvent, or files a petition for commencement of bankruptcy proceedings, civil rehabilitation proceedings, corporate reorganization proceedings, special liquidation proceedings, or any other similar proceedings<br/>
										(5) If you have not responded to our inquiries or other communications requesting a response for 30 days or more<br/>
										(6) If any of the items of Article 3, Paragraph 4 applies.<br/>
										(7) In any other case in which we deem it inappropriate for you to use the Service or to continue your registration as a registered user.<br/>
										2 In the event of any of the events listed in the preceding paragraph, the registered user shall naturally lose the benefit of time with respect to all debts owed to the company or the seller, and must immediately make payment of all debts owed to the company or the seller.<br/>
										3 In the event of any of the events listed in the preceding paragraph, the Company may erase all or part of the Service data pertaining to the Registered User.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Withdrawal from membership)</div>
									<div class="title-2">Article 11.</div>
									<div class="text-1">
										　A registered user may withdraw from the Service and delete his/her registration as a registered user upon completion of the procedures prescribed by the Company.<br/>
										2 Upon withdrawal from membership, if there are any debts owed to the company or the Seller, the Registered User shall naturally lose the benefit of time with respect to all debts owed to the company or the Seller, and must immediately pay all such debts to the company or the Seller.<br/>
										3 The handling of user information after withdrawal from membership shall be in accordance with the provisions of Article 15.<br/>
										4 The Company may erase all or part of the data of the Service pertaining to a registered user who has withdrawn from membership.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Change or Termination of the Service)</div>
									<div class="title-2">Article 12.</div>
									<div class="text-1">
										　1 The Company may, for its own reasons, change the contents of the Service, or discontinue or terminate provision of the Service without notice to the Registered Users.<br/>
										2. The Company shall not be liable for any damages incurred by the registered user as a result of changes to the contents of the Service, etc., as described in the preceding paragraph.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Disclaimer of Warranty, Disclaimer of Liability, etc.)</div>
									<div class="title-2">Article 13.</div>
									<div class="text-1">The Company shall not be liable to the Registered Users for any damages arising out of the use of the Service, whether express or implied, including, but not limited to, that the Service is fit for the specific purpose of the Registered Users, that the Service has the expected functions, product value, accuracy, and usefulness, that the use of the Service by the Registered Users complies with applicable laws and regulations or internal regulations of industry organizations, that the Service is continuously available, and that no defects will occur. (2) We make no warranty, express or implied, with respect to the Service.<br/>
										2. We shall not be liable for any damages incurred by registered users in connection with the service.<br/>
										3 Registered Users shall be responsible for resolving any transactions, communications, disputes, etc. between them and other Registered Users or third parties in connection with the Service or our website.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Confidentiality)</div>
									<div class="title-2">Article 14.</div>
									<div class="text-1">
										　Registered Users shall treat as confidential any non-public information disclosed by us to Registered Users in connection with the Service, which we require to be treated as confidential, unless otherwise agreed in writing in advance by us.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Handling of User Information)</div>
									<div class="title-2">Article 15.</div>
									<div class="text-1">
										　The Company's handling of Registered Users' user information shall be governed by the separate privacy policy of the Company, and Registered Users shall agree to the Company's handling of their user information in accordance with this privacy policy.<br/>
										2. We may, at our discretion, use and disclose information, data, etc. provided by registered users to us as statistical information in a form that does not identify individuals, and registered users shall not object to this.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Modification of these Terms of Use, etc.)</div>
									<div class="title-2">Article 16.</div>
									<div class="text-1">
										　The Company may change the Terms of Use as deemed necessary by the Company. In the event of modification of the Terms of Use, the Company shall notify the Registered Users of the effective date and contents of the modified Terms of Use by posting on the Company's website or by any other appropriate means. However, in the case of changes that require the consent of the registered user under the law, the consent of the registered user shall be obtained in a manner prescribed by the Company.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Communication and Notification)</div>
									<div class="title-2">Article 17.</div>
									<div class="text-1">
										Inquiries regarding the Service and other communications or notifications from registered users to the Company, as well as notifications regarding changes to the Terms of Use and other communications or notifications from the Company to registered users, shall be made in the manner prescribed by the Company.<br/>
										2. When we contact or notify the e-mail address or other contact address included in the registration information, the Registered User shall be deemed to have received such contact or notification.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Transfer of Status under Service Usage Contract, etc.)</div>
									<div class="title-2">Article 18.</div>
									<div class="text-1">
										Registered Users may not assign, transfer, pledge as collateral, or otherwise dispose of their status under the Service Agreement or their rights or obligations under this Agreement to any third party without the prior written consent of the Company.<br/>
										2. In the event of transfer of the business related to the Service to another company, we may transfer the position under the service agreement, rights and obligations under the Terms of Use, and registered user's registered matters and other customer information to the transferee of such business transfer, and the registered user agrees in advance to such transfer in this section. Registered Users shall be deemed to have consented to such transfer in advance in this paragraph. The business transfer stipulated in this section shall include not only ordinary business transfers, but also corporate divestitures and any other cases in which business is transferred.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Exclusion of Anti-Social Forces)</div>
									<div class="title-2">Article 19.</div>
									<div class="text-1">
										　Registered Users represent and warrant that they do not fall under any one of the following items, and will not fall under any one of the following items in the future.<br/>
										(1) The Registered User (in the case of a corporation or other organization, including its directors and officers) does not fall under any of the following items.  That he/she (or, in the case of a corporation or other organization, its officers) is a Bouryokudan, a Bouryokudan member, a person for whom five years have not passed since he/she ceased to be a Bouryokudan member, a quasi-organization member of a Bouryokudan, a company related to a Bouryokudan, a general meeting house, a socially motivated group or special intelligence violent group or other person similar thereto (hereinafter collectively referred to as "Bouryokudan Member, etc.") The Registered User is a corporation or other organization.<br/>
										(2) In the case of a juridical person or other organization, the registered user has a relationship with a person who is deemed to be controlled by a Bouryokudanin, etc.<br/>
										(3) In the case of a juridical person or other organization, the registered user has a relationship in which Boryokudan-in etc. is deemed to be substantially involved in the management of the organization.<br/>
										(4) The registered user has a relationship that is recognized as taking advantage of Bouryokudan-in etc., such as conducting transactions for the purpose of making unjust profits for oneself or a third party, or for the purpose of inflicting damage on a third party.<br/>
										(5) Having a relationship that is deemed to involve Bouryokudanin, etc., such as providing funds, etc., or offering favors, etc., to Bouryokudanin, etc.<br/>
										(6) In the case of a juridical person or other organization, to have a socially reprehensible relationship with Bouryokudan-in etc. by its own officers or those substantially involved in its management.<br/>
										2 Registered Users shall guarantee that they will not commit any of the following acts by themselves or by using a third party<br/>
										(1) Violent demands<br/>
										(2) Unjust demand beyond legal responsibility<br/>
										(3) threatening words or deeds or using violence in connection with transactions<br/>
										(4) Any act to damage the Company's credibility or obstruct the Company's business by spreading false rumors, using deceptive means, or using force.<br/>
										(5) Any other acts similar to the preceding items.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Severability)</div>
									<div class="title-2">Article 20.</div>
									<div class="text-1">
										　If any provision of these Terms and Conditions or part thereof is determined to be invalid or unenforceable under the Consumer Contract Act or other laws or regulations, the remaining provisions of these Terms and Conditions and the remaining portions of any provision that is determined to be invalid or unenforceable in part shall remain in full force and effect.<br/>
									</div>
								</div>
								<div class="article-1">
									<div class="title-1">(Governing Law and Court of Jurisdiction)</div>
									<div class="title-2">Article 21.</div>
									<div class="text-1">
										　These Terms and the Service Usage Agreement shall be governed by and construed in accordance with the laws of Japan.<br/>
										The Tokyo District Court shall be the exclusive court of first instance for any and all disputes arising out of or in connection with these Terms of Use or the Service Usage Agreement.<br/>
									</div>
								</div>
								Enacted on September 1, 2021
							</div>

						</mat-card-content>
					</mat-card>
				</div>
			</ng-container>
		</mat-dialog-content>

		<div class="spacer"></div>

		<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around" style="margin:6px;">
			<button *ngIf="isEndScroll" color="primary" mat-dialog-close="" mat-raised-button>Confirm</button>
			<button *ngIf="!isEndScroll" [disabled]="!isEndScroll" color="primary" mat-raised-button>Confirm</button>
		</mat-dialog-actions>
	</ng-container>
</div>
